// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3fVqTJ52bCpU","button":"_358tkHYWgIXX","createRequest":"_1p3bF3gKxzvD"};